var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9198 4.94118C13.9198 4.42138 13.4984 4 12.9786 4C12.4588 4 12.0374 4.42138 12.0374 4.94118V11.0588L5.91969 11.0587C5.39989 11.0587 4.97852 11.4801 4.97852 11.9999C4.97852 12.5197 5.39989 12.9411 5.91969 12.9411H12.0374V19.0588C12.0374 19.5786 12.4588 20 12.9786 20C13.4984 20 13.9198 19.5786 13.9198 19.0588V12.9411H20.0373C20.5571 12.9411 20.9785 12.5197 20.9785 11.9999C20.9785 11.4801 20.5571 11.0588 20.0373 11.0588L13.9198 11.0588V4.94118Z",
    fill: "#005CA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/More.3bd771dde0c560f9e9bc62d3c6af8c44.svg";
export { ForwardRef as ReactComponent };